import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import RelativeTime from 'dayjs/plugin/relativeTime'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setFavorite, unsetFavorite } from '../../../../../redux/actions/favorites'
import { showNoveltyBySlug, toggleFormNovelty } from '../../../../../redux/actions/novelties'
import { IRootState } from '../../../../../redux/types'
import { INovelty } from '../../../novelties/models/novelties'

dayjs.extend(LocalizedFormat)
dayjs.extend(RelativeTime)

export const useNewsDetailsPanel = (news: any[]) => {
  const dispatch = useDispatch()
  const { user: authUser } = useSelector((state: IRootState) => state.auth)

  const [sortNews, setSortNews] = useState<INovelty[]>([])

  useEffect(() => {
    if (news && news.length > 0) {
      const tmpSortNews = [...news].sort((a: any, b: any) => {
        if (a.id > b.id) return -1
        if (a.id < b.id) return 1
        return 0
      })
      setSortNews(tmpSortNews)
    }
  }, [news])

  const handleShowNews = (slug: string) => {
    dispatch(showNoveltyBySlug({ slug, type: 'newsSelected' }))
  }

  const handleEdit = () => {
    dispatch(toggleFormNovelty({ type: 'newsSelected', change: false }))
  }

  const cutContent = (content: string) => {
    const endPos = content.indexOf('</p>')
    if (endPos === -1) return content.substr(0, 100)
    return content.substr(0, Math.min(content.length, endPos))
  }

  const handleFavoriteNewsClick = (news_id: number) => (state: boolean) => {
    if (state) {
      dispatch(
        setFavorite({
          id: news_id,
          state,
          type: 'novelty',
          favoritefield: 'news'
        })
      )
    } else {
      dispatch(
        unsetFavorite({
          id: news_id,
          state,
          type: 'novelty',
          favoritefield: 'news'
        })
      )
    }
  }

  return {
    sortNews,
    authUser,
    setSortNews,
    handleShowNews,
    handleEdit,
    cutContent,
    handleFavoriteNewsClick
  }
}
